export const getAgencyAddonsUrl = () => 'agency/addons';

export const getAgencyAddonUrl = (id: string | number) => `agency/addons/${id}`;
